import Environment from '../../../Environment';
import { IFilter, IInclude, IPage, ISort, buildUrl } from '../../BaseService';

export interface IPrepareMediaPlaysUrl {
  filters?: IFilter[];
  id?: string;
  includes?: IInclude[];
  pages?: IPage[];
  sorts?: ISort[];
}

export function prepareMediaPlaysUrl({
  filters,
  pages,
  id,
  includes,
  sorts,
}: IPrepareMediaPlaysUrl): string {
  return buildUrl({
    host: Environment.mediaPersonalizationService,
    resource: 'media-plays',
    filters,
    pages,
    includes,
    id,
    sorts,
  });
}
